/*********************************************
 * OPTION VALUES
 *********************************************/
export const SET_BREADCRUMB_TO = 'SET_BREADCRUMB_TO'
export const SET_CURRENT_THEME = 'SET_CURRENT_THEME'
export const SET_CURRENT_CASE = 'SET_CURRENT_CASE'

export const SET_CURRENT_PAGE_INDEX = 'SET_CURRENT_PAGE_INDEX';
export const SET_CURRENT_PAGE_PHASE = 'SET_CURRENT_PAGE_PHASE';
export const CLEAR_PAGE_HISTORY = 'CLEAR_PAGE_HISTORY';

export const SET_GAME_CLIENT_CLOSE_REDIRECT_URL = 'SET_GAME_CLIENT_CLOSE_REDIRECT_URL';
export const SET_LAST_EMOJI_CODE = 'SET_LAST_EMOJI_CODE';

export const SET_CURRENT_GAME_PHASE = 'SET_CURRENT_GAME_PHASE'

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_ERROR_ICON = 'SET_ERROR_ICON'
export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE'
export const SET_NAVIGATION_GUARD_ENABLED = 'SET_NAVIGATION_GUARD_ENABLED'
export const SET_GAME_TYPE = 'SET_GAME_TYPE';
export const SET_GAME_CLIENT_TYPE = 'SET_GAME_CLIENT_TYPE';

export const SET_LANGUAGE = 'SET_LANGUAGE';

export const ADD_VOTES = 'ADD_VOTES';
